import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchVersionListingData } from "../../redux/reducers/apiSlice";
import { selectAuth } from "../auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
import { Col, Container, Row } from "react-bootstrap";
import CommonStructured from "../common-components/CommonStructured";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import { AppOptions, VersionColumns } from "./versionutils";
import Modal from "react-modal";
import AddVersion from "./AddVersionForm";
import "./version.css"
import SelectDropdown from "../components-react/SelectDropdown";
import FilterContainer from "../common-components/filters/filter-container";

const VersionLanding = () => {
  const dispatch = useDispatch();
  const authData = useSelector(selectAuth);
  const userInfoData = authData?.user;

  const [isPage, setIsPage] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [pageLimit, setPageLimit] = useState(10);
  const [expandRow, setExpandRow] = useState(null);

  function onCloseModalvalues() {
    setModalOpen(false);
  }

  const { versionData, loading } = useSelector((state) => state.api);

  const initialFilter = {
    type: "",
    limit: 10,
    page: isPage + 1,
    pageLimit: pageLimit,
  };

  const [filters, setFilters] = useState(initialFilter);

  useEffect(() => {
    setFilters((prev) => ({
      ...prev,
      limit: pageLimit,
      page: isPage + 1,
    }));
  }, [isPage, pageLimit]);

  useEffect(() => {
    getVersionData();
  }, [filters]);

  useEffect(() => {
    setIsPage(0);
  }, [filters.type]);


  const getVersionData = () => {
    dispatch(
      fetchVersionListingData({
        filters,
        token: userInfoData?.token,
      })
    );
  };

  useEffect(() => {
    getVersionData();
  }, [userInfoData?.token]);

  const handleReset = () => {
    setFilters(initialFilter);
  };

  const VersionFinalColumn = useMemo(
    () => VersionColumns(expandRow, setExpandRow),
    [expandRow]
  );

  return (
    <HelmetWrapper title="WTF: Version">
      <Container className="bg-cloud-k px-50px" fluid>
        <Row>
          <Col>
            <CommonStructured
              pageHeading={"App Version"}
              createBtnTxt={"Add New Version"}
              onClickCreateBtn={() => setModalOpen(true)}
              isReload={() => getVersionData(filters)}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <div className="mt-3">
            <FilterContainer onReset={handleReset}>


              <div className="timesheet_dropdown_wrapper">
                <SelectDropdown
                  options={AppOptions}
                  setSelectedOption={(option) => {
                    setFilters({
                      ...filters,
                      type: option?.value || "",
                    });
                  }}
                  name="Type"
                />
              </div>
            </FilterContainer>
            </div>
          </Col>
        </Row>

        <div>
          <Modal
            isOpen={modalOpen}
            onRequestClose={onCloseModalvalues}
            contentLabel="Version"
            ariaHideApp={false}
          >
            <AddVersion
              getVersionData={getVersionData}
              closeModal={onCloseModalvalues}
              token={userInfoData?.token}
            />
          </Modal>

          <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt-3">
            {loading ? (
              <ReactVortoxSpinner />
            ) : (
              <PaymentLinkTable
                tableData={
                  versionData?.data?.length > 0 ? versionData?.data : []
                }
                tableColumns={VersionFinalColumn}
                tablePagination={versionData?.pagination || {}}
                isPage={isPage}
                setIsPage={(value) => setIsPage(value)}
                setPageLimit={setPageLimit}
                pageLimit={pageLimit}
              />
            )}
          </div>
        </div>
      </Container>
    </HelmetWrapper>
  );
};

export default VersionLanding;
